<script setup lang="ts">
import SliderChapters from './SliderChapters.vue';
import SliderPreview from './SliderPreview.vue';
import SliderThumb from './SliderThumb.vue';
import MarkerBar from '@/front/components/MarkerBar.vue';
import { VideoStore } from '@/front/stores/video_store.js';
const videoStore = VideoStore();
import { PlayerStore } from '@/front/stores/player_store.js';
const playerStore = PlayerStore();
import { AnnStore } from '@/front/stores/ann_store.js';
const annStore = AnnStore();
const { thumbnails } = defineProps<{
  thumbnails?: string;
}>();

const design = computed(() => {
  return videoStore.video.design;
})

const manage = computed(() => {
  return videoStore.video.manage;
})

const showMarkerBar = computed(() => {
  if (playerStore.isDebug) {
    return true
  }
  return playerStore.playerState.controlsVisible && videoStore.video.id && annStore && !annStore.loading && (videoStore.video.manage || (videoStore.video.design.show_seekbar && videoStore.video.design.show_markers))
})

const showTime = computed(() => {
  if (playerStore.isDebug) {
    return true
  }
  if (videoStore.video.manage) {
    return true
  }
  if (design.value) {
    return design.value.show_time
  }
  return true
})

import { useGlobalRenderTracker } from '@/front/composables/GlobalRenderTracker.js'
if (playerStore.isDebugPerformance) {
  useGlobalRenderTracker('TimeSlider', { logLevel: 'none' })
}

const handleClick = () => {
  log.info(5,"💟 TimeSlider handleClick")
  annStore.markIntentionalSeek();
}
</script>

<template>
  <media-time-slider
    v-if="manage || playerStore.isDebug || (design && design.show_seekbar && !design.hide_controls)"
    id="time-slider"
    @click="handleClick"
    :disabled="!manage && !design.seekbar_active && !playerStore.isDebug"
    class="group relative mx-[7.5px] inline-flex h-10 w-full cursor-pointer touch-none select-none items-center outline-none"
  >
    <SliderChapters />
    <SliderThumb class="mb-2 "/>
    <SliderPreview v-show="!annStore.hoverAnn" :thumbnails="thumbnails" class="bg-black/70 rounded-lg" :class="{ 'py-2 px-2': !videoStore.video.has_thumbnails }">
      <div class="text-sm" data-part="chapter-title" />
      <media-slider-value v-if="showTime" class="text-sm" :class="{ 'pb-2': !!thumbnails }" />
    </SliderPreview>
    <MarkerBar v-if="showMarkerBar" />
  </media-time-slider>

</template>
